module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tip) ? _c('div', {
    staticClass: "upload-tip",
    class: {
      'small': _vm.size === 'small', 'tine': _vm.size === 'tine'
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.tip,
      "type": "info",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.mult) ? _c('div', {
    staticClass: "mc-upload-wrap"
  }, [_c('div', {
    directives: [{
      name: "imageupload",
      rawName: "v-imageupload",
      value: (_vm.img),
      expression: "img"
    }],
    staticClass: "upload-field",
    class: {
      'has-upload': _vm.img, 'small': _vm.size === 'small', 'tine': _vm.size === 'tine'
    },
    on: {
      "upload-change": _vm.singleImgUplad
    }
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请上传图片")]), _vm._v(" "), _c('div', {
    staticClass: "pic-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-cover"
  }, [_vm._v("点击图片以修改")])])]) : _c('div', {
    staticClass: "mc-upload-wrap mult-wrap"
  }, _vm._l((_vm.multImgList), function(item, i) {
    return _c('div', {
      directives: [{
        name: "imageupload",
        rawName: "v-imageupload",
        value: (item),
        expression: "item"
      }],
      key: i,
      staticClass: "upload-field tine ftp",
      class: {
        'has-upload': item
      },
      on: {
        "upload-change": function($event) {
          return _vm.multImgUplad($event, i)
        }
      }
    }, [_c('div', {
      staticClass: "tip"
    }, [_vm._v("请上传图片")]), _vm._v(" "), _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "upload-cover"
    }, [_vm._v("点击图片以修改")]), _vm._v(" "), (i !== _vm.multImgList.length - 1) ? _c('div', {
      staticClass: "del-btn ic-del",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delImg(i)
        }
      }
    }) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1a4c851d","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/img-upload/img-upload.vue
// module id = 736
// module chunks = 1